import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useCart, optionsLabel } from '../context/CartContext';

export const CartItem = ({ item }) => {
  const { updateCartItem, removeFromCart, loading } = useCart();

  const handleQuantityChange = async (newQuantity) => {
    if (newQuantity <= 0) {
      await removeFromCart(item.item_id, item.options);
    } else {
      await updateCartItem(item.item_id, newQuantity, item.options);
    }
  };

  const label = optionsLabel(item.options);

  return (
    <div
      className="flex items-center space-x-4 p-4 bg-white rounded-xl border border-stone-100"
      data-testid={`cart-item-${item.item_id}`}
    >
      <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
        <img src={item.image_url} alt={item.name} className="w-full h-full object-cover" />
      </div>

      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-foreground truncate">{item.name}</h4>
        <p className="text-sm text-muted-foreground">
          {(item.unit_price ?? item.price).toFixed(2)} € / unité
        </p>
        {label && (
          <p className="text-xs text-accent mt-1 font-medium" data-testid={`cart-item-options-${item.item_id}`}>
            {label}
          </p>
        )}
      </div>

      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8 rounded-full"
          onClick={() => handleQuantityChange(item.quantity - 1)}
          disabled={loading}
          data-testid={`decrease-quantity-${item.item_id}`}
        >
          <Minus className="h-3 w-3" />
        </Button>

        <span className="w-8 text-center font-medium" data-testid={`quantity-${item.item_id}`}>
          {item.quantity}
        </span>

        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8 rounded-full"
          onClick={() => handleQuantityChange(item.quantity + 1)}
          disabled={loading}
          data-testid={`increase-quantity-${item.item_id}`}
        >
          <Plus className="h-3 w-3" />
        </Button>
      </div>

      <div className="text-right">
        <p className="font-bold text-primary">{item.subtotal.toFixed(2)} €</p>
      </div>

      <Button
        variant="ghost"
        size="icon"
        className="text-destructive hover:text-destructive hover:bg-destructive/10"
        onClick={() => removeFromCart(item.item_id, item.options)}
        disabled={loading}
        data-testid={`remove-item-${item.item_id}`}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default CartItem;
